/**
 * The shape every form control shares.
 *
 * Extracted from Field.tsx so that controls living in their own file — the date
 * picker, and whatever follows it — cannot drift a border colour or a height
 * away from the text input sitting next to them in the same form grid. v1's
 * inputs disagreed on all three of height, radius and focus treatment depending
 * on which stylesheet had reached them last.
 *
 * 32px tall, rounded `md`, ruled rather than shadowed.
 */

export const controlBase =
  'h-8 w-full rounded-md border bg-surface px-2 text-sm text-ink ' +
  'transition-colors duration-100 ' +
  'placeholder:text-faint ' +
  'disabled:cursor-not-allowed disabled:bg-subtle disabled:text-faint';

export const controlTone = (invalid?: boolean) =>
  invalid
    ? 'border-danger focus:border-danger'
    : 'border-line-strong hover:border-faint focus:border-accent';
